// extracted by mini-css-extract-plugin
export default {"support__buttonGroup":"Support_support__buttonGroup__BDqDV","support__dataButton":"Support_support__dataButton__zVdEb"};